export { default } from './TrophyThree'
